module.exports = __webpack_public_path__ + "assets/img/process-5.47bfe7f0.png";